import { render, staticRenderFns } from "./EventInvite.vue?vue&type=template&id=04097fe5&"
import script from "./EventInvite.vue?vue&type=script&lang=js&"
export * from "./EventInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports